export const config = (theirMonthOffer, discountDuration, secondBoxDiscount) => ({
  youGetTitle: 'You get',
  yourFriendGetsTitle: 'Your friend gets',
  youGetDescription: 'when their first order is delivered',
  yourFriendGetsDescription: secondBoxDiscount
    ? `off their first box + ${secondBoxDiscount} off their 2nd box + ${theirMonthOffer} off their first ${discountDuration}`
    : `off their first order + ${theirMonthOffer} off their first ${discountDuration}`,
})
